import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';

@Injectable({
  providedIn: 'root'
})
export class CajaDiariaService {

  constructor(
    private gqlclient: GraphQLClient
  ) { }

  GetByCajaDiariaTransportista(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: declaracion_controlInputType) {
          declaracion_control {
            reporteCajaDiariaResumenTransportista(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                empresa_rut
                sucursal_codigo
                monto_efectivo
                monto_cheque
                monto_deposito
                monto_transferencia
                bancos {
                  codigo
                  nombre
                  monto_transferencia
                }
                monto_credito
                diferencia
                diferencia_monto
                diferencia_monto_ingreso
                diferencia_monto_egreso
                pago_cuenta_utilizado
                gasto
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.declaracion_control.reporteCajaDiariaResumenTransportista
        callback({ mensajes, respuesta })
      }
    );
  }

  GetByCajaDiariaVendedores(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: declaracion_controlInputType) {
          declaracion_control {
            reporteCajaDiariaResumenVendedor(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                empresa_rut
                sucursal_codigo
                monto_efectivo
                monto_cheque
                monto_deposito
                monto_transferencia
                bancos {
                  codigo
                  nombre
                  monto_transferencia
                }
                monto_credito
                diferencia
                diferencia_monto
                diferencia_monto_ingreso
                diferencia_monto_egreso
                pago_cuenta_utilizado
                gasto
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.declaracion_control.reporteCajaDiariaResumenVendedor
        callback({ mensajes, respuesta })
      }
    );
  }

  GetByCajaDiariaCajaLocal(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: declaracion_controlInputType) {
          declaracion_control {
            reporteCajaDiariaResumenOficina(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                empresa_rut
                sucursal_codigo
                monto_efectivo
                monto_cheque
                monto_deposito
                monto_transferencia
                bancos {
                  codigo
                  nombre
                  monto_transferencia
                }
                monto_credito
                diferencia
                diferencia_monto
                diferencia_monto_ingreso
                diferencia_monto_egreso
                pago_cuenta_utilizado
                gasto
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.declaracion_control.reporteCajaDiariaResumenOficina
        callback({ mensajes, respuesta })
      }
    );
  }

  GetByCajaDiariaResumen(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: declaracion_controlInputType) {
          declaracion_control {
            reporteCajaDiariaResumenTotal(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                empresa_rut
                sucursal_codigo
                monto_efectivo
                monto_cheque
                monto_deposito
                monto_transferencia
                bancos {
                  codigo
                  nombre
                  monto_transferencia
                }
                monto_credito
                diferencia
                diferencia_monto
                diferencia_monto_ingreso
                diferencia_monto_egreso
                pago_cuenta_utilizado
                gasto
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.declaracion_control.reporteCajaDiariaResumenTotal
        callback({ mensajes, respuesta })
      }
    );
  }

  GetByCajaDiariaDepositoRetiro(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: declaracion_controlInputType) {
          declaracion_control {
           reporteCajaDiariaRetirosDepositos(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                empresa_rut
                sucursal_codigo
                pago_proveedores
                pago_caja_chica
                deposito_efectivo
                monto_protesto_cheque
                monto_reverso
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.declaracion_control.reporteCajaDiariaRetirosDepositos
        callback({ mensajes, respuesta })
      }
    );
  }

  GetByTotalCajaDiaria(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: declaracion_controlInputType) {
          declaracion_control {
           cajaDiariaTotal(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                empresa_rut
                sucursal_codigo
                total_ingreso
                total_egreso
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.declaracion_control.cajaDiariaTotal
        callback({ mensajes, respuesta })
      }
    );
  }

  GetByPDFCajaDiaria(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: declaracion_controlInputType) {
          declaracion_control {
             cajaDiariaPDF(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                rutaArchivo
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.declaracion_control.cajaDiariaPDF
        callback({ mensajes, respuesta })
      }
    );
  }
}
